import { withStyles } from '@material-ui/core';
import CardHeader from './CardHeader';
import styles from './styles';

export default withStyles(styles)(CardHeader);
